/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from "react";
import "./navFilter.css";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import {
  List, ListItemText, ListItem, ListSubheader,
  Checkbox,
} from "@material-ui/core";
import { connect } from "react-redux";
import { FixedSizeList } from "react-window";
import { SearchBar } from "../searchView/searchComponent";
import { selectedCity } from "../../../redux/actions/citiesAction";
import { selectedOperator } from "../../../redux/actions/operatorsAction";
import { useStyles, listDetailsBySource } from "../../../lib/navBar";

function renderFilterContent(
  isNotOperationType,
  isNotReportsType,
  filterHeader,
  options,
  operationTypeFilter,
) {
  if (isNotOperationType) {
    if (isNotReportsType) {
      return (
        <span className="top-filter-title">
          {filterHeader}
        </span>
      );
    }
    return (
      <span className="top-filter-title">
        {options.length && "Reports"}
      </span>
    );
  }
  return (
    <span className="top-filter-operationtype">
      {options.length ? (operationTypeFilter || (options[0] && options[0].displayName)) : "All"}
    </span>
  );
}

const checkOperationTypeAndNotReportsType = (
  isNotOperationType,
  isNotReportsType,
) => isNotOperationType && isNotReportsType;

const handleCitySource = ({
  setHeader,
  setSelected,
  breakDownView,
  selected,
  cities,
  options,
  source,
}) => {
  let paramValue = [];
  let displayData = [];
  setHeader("operator", "All Operators");
  setSelected("operator", []);
  selectedOperator([]);
  if (!breakDownView && (selected.length === cities.length || selected.length === 0)) {
    paramValue = [];
    setHeader(source, "All Cities");
  } else if (selected.length > 1) {
    paramValue = selected;
    setHeader(source, "Multi Cities");
  } else if (selected.length === 1) {
    paramValue = selected;
    displayData = options.filter((data) => data.uniqId === paramValue[0]);
    (displayData.length === 1) ? setHeader(source, `${displayData[0].cityName}`) : setHeader(source, "Multi Cities");
  }
  return paramValue;
};

const handleSubmitClick = ({
  source,
  setHeader,
  selected,
  operators,
  options,
  onMenuSelection,
  setSelected,
  breakDownView,
  cities,
  setAnchorEl,
}) => {
  setAnchorEl(false);
  let paramValue = [];
  let displayData = [];
  if (source === "city") {
    paramValue = handleCitySource({
      setHeader,
      setSelected,
      breakDownView,
      selected,
      cities,
      options,
      source,
    });
  } else if (source === "operator") {
    if (selected.length === operators.length || selected.length === 0) {
      paramValue = [];
      setHeader(source, "All Operators");
    } else {
      paramValue = selected.map((id) => (id.match("^([^-])+")[0]).toString());
      if (selected.length > 1) {
        setHeader(source, "Multi Operators");
      } else {
        displayData = options.filter((data) => data.operatorId === paramValue[0]);
        (displayData.length === 1) ? setHeader(source, `${displayData[0].displayName}`) : setHeader(source, "Multi Operators");
      }
    }
  }
  onMenuSelection(paramValue);
};

const handleMenuItemClick = (event, option, {
  setselectedId,
  setOperationTypeFilter,
  onMenuSelection,
  setSelected,
  source,
  selected,
}) => {
  if (source === "operationType") {
    setselectedId(option.uniqId);
    setOperationTypeFilter(option.displayName);
    onMenuSelection(option.value);
  } else if (source === "reportsType") {
    setselectedId(option.uniqId);
    onMenuSelection(option.value);
  } else {
    const selectedIndex = selected.indexOf(option.uniqId);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, option.uniqId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(source, newSelected);
  }
};

const handleSelectAllClick = (event, {
  setHeader, setSelected, source, options,
}) => {
  setHeader(source);
  if (event.target.checked && options) {
    const newSelecteds = options.map((n) => n.uniqId);
    setSelected(source, newSelecteds);
    return;
  }
  setSelected(source, []);
};

const getSelectedBoolean = (
  isNotOperationType,
  isNotReportsType,
  isItemSelected,
  selectedId,
  option,
  index,
) => {
  let selectedBool;
  if (checkOperationTypeAndNotReportsType(
    isNotOperationType,
    isNotReportsType,
  )) {
    selectedBool = isItemSelected;
  } else if (selectedId) {
    selectedBool = option.uniqId === selectedId;
  } else {
    selectedBool = index === 0;
  }
  return selectedBool;
};

const renderAllSelectedCheckbox = (
  setHeader,
  setSelected,
  source,
  options,
  selected,
) => (
  <Checkbox
    indeterminate={
      selected.length > 0 && selected.length < options.length
    }
    checked={
      options.length > 0 && selected.length === options.length
    }
    onChange={(event) => handleSelectAllClick(event, {
      setHeader, setSelected, source, options,
    })}
    inputProps={{ "aria-label": "select all desserts" }}
  />
);

const updateHeader = (source, operatorFilter, setHeader) => {
  if (source === "operator" && !operatorFilter) {
    setHeader(source, "All Operators");
  }
};

const getFixedListHeight = (
  source,
) => ((listDetailsBySource[source] || {}).height || 100);

const getFixedListItemSize = (source) => ((listDetailsBySource[source] || {}).itemSize || 30);

function NavFilter(props) {
  const {
    options = [], source, setHeader, setSelected,
    breakDownView, selected, cities, operators, onMenuSelection, operatorFilter,
    filterHeader, onSearch,
  } = props;
  const [isAnchorEl, setAnchorEl] = useState(false);
  const [selectedId, setselectedId] = useState(0);
  const [operationTypeFilter, setOperationTypeFilter] = useState("All");
  const classes = useStyles();
  const isNotOperationType = (source !== "operationType");
  const isNotReportsType = (source !== "reportsType");
  const ITEM_HEIGHT = 60;
  const anchorEl = useRef(null);

  const handleClick = () => {
    setAnchorEl(true);
  };

  const handleClose = () => {
    setAnchorEl(false);
  };

  const isSelected = (name) => selected?.indexOf(name) !== -1;

  const listItem = ({
    index,
    style,
  }) => {
    const option = options[index];
    const isItemSelected = isSelected(option.uniqId);
    const labelId = `transfer-list-all-item-${index}-label`;
    return (
      <ListItem
        key={option.uniqId}
        button
        className={classes.MuiListItemDense}
        selected={() => getSelectedBoolean(
          isNotOperationType,
          isNotReportsType,
          isItemSelected,
          selectedId,
          option,
          index,
        )}
        onClick={(event) => handleMenuItemClick(event, option, {
          setselectedId,
          setOperationTypeFilter,
          onMenuSelection,
          setSelected,
          source,
          selected,
        })}
        style={style}
      >
        {(checkOperationTypeAndNotReportsType(
          isNotOperationType,
          isNotReportsType,
        ))
          && (
            <Checkbox
              checked={isItemSelected}
              inputProps={{ "aria-labelledby": labelId }}
            />
          )}
        <ListItemText
          id={labelId}
          className={classes.textDecoration}
          primary={source === "city" ? option?.cityName : option?.displayName}
        />
      </ListItem>
    );
  };

  useEffect(() => {
    updateHeader(source, operatorFilter, setHeader);
  }, [source, operatorFilter]);

  const listItemTextObject = {
    city: "All Cities",
    operator: "All Operators",
  };

  return (
    <div className={isNotOperationType ? "filter-container" : "filter-container-operationtype"}>
      <Button aria-controls="long-menu" aria-haspopup="true" onClick={handleClick} style={{ maxHeight: "32px" }} ref={anchorEl}>
        <div className="top-filter">
          {renderFilterContent(
            isNotOperationType,
            isNotReportsType,
            filterHeader,
            options,
            operationTypeFilter,
          )}
          <img className={isAnchorEl ? "arrow-up" : "arrow-down"} alt="Logo" src="/images/toggle.png" />
        </div>
      </Button>
      <Popover
        id="long-menu"
        anchorEl={anchorEl.current}
        open={isAnchorEl}
        onClick={(checkOperationTypeAndNotReportsType(
          isNotOperationType,
          isNotReportsType,
        )) ? () => { /* onClick */ } : handleClose}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom" }}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 5,
          },
        }}
        className="navigation-dropdown"
      >
        <div className={source === "operator" ? "operatorDropdown" : "cityDropdown"}>
          {source === "operator" && (
            <div className={classes.searchWrapper}>
              <SearchBar
                placeHolder="Search"
                onSearchChange={(e) => {
                  onSearch(e);
                }}
              />
            </div>
          )}
          <div>
            <List
              className={
                (checkOperationTypeAndNotReportsType(
                  isNotOperationType,
                  isNotReportsType,
                )) ? classes.menuList : "menuList"
              }
              dense
            >
              {(checkOperationTypeAndNotReportsType(
                isNotOperationType,
                isNotReportsType,
              ))
                && (
                  <ListItem className={classes.MuiListItemDense}>
                    {renderAllSelectedCheckbox(
                      setHeader,
                      setSelected,
                      source,
                      options,
                      selected,
                    )}
                    <ListItemText
                      className={classes.textDecoration}
                      primary={listItemTextObject?.[source] ?? "All"}
                    />
                  </ListItem>
                )}
              <FixedSizeList
                className={(checkOperationTypeAndNotReportsType(
                  isNotOperationType,
                  isNotReportsType,
                )) ? classes.menuList : "menuList"}
                height={getFixedListHeight(source)}
                width="100%"
                itemSize={getFixedListItemSize(source)}
                itemCount={options.length}
              >
                {/* Row to render */}
                {listItem}
              </FixedSizeList>
              {(checkOperationTypeAndNotReportsType(
                isNotOperationType,
                isNotReportsType,
              ))
                && (
                  <ListSubheader className={classes.applyFilter}>
                    <Button
                      onClick={() => handleSubmitClick({
                        source,
                        setHeader,
                        selected,
                        operators,
                        options,
                        onMenuSelection,
                        setSelected,
                        breakDownView,
                        cities,
                        setAnchorEl,
                      })}
                      style={{ color: "#fff", minWidth: "-webkit-fill-available" }}
                    >
                      Apply
                    </Button>
                  </ListSubheader>
                )}
            </List>
          </div>
        </div>
      </Popover>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    cities: state.Cities.cities,
    city: state.Cities.selectedCity,
    cityOperators: state.Operators.cityOperators,
    breakDownView: state.BreakDown.breakDownView,
    operators: state.Operators.operators,
    operatorFilter: state.Operators.selectedOperator,
    selectedTabMenu: state.Auth.selectedMenu,
    user: state.Auth.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  selectedCity: (cityId) => {
    dispatch(selectedCity(cityId));
  },
  selectedOperator: (params) => {
    dispatch(selectedOperator(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavFilter);
